if (!customElements.get('broderie-form')) {
  customElements.define('broderie-form', class BroderieForm extends HTMLElement {
    constructor() {
      super();
      this.inputTextValue = this.querySelector('#Broderie-text-value');
      this.inputText = this.querySelector('#Broderie-Text');
      this.log = this.querySelector('#Broderie-log');
      // Select all inputs not hidden and not read only
      this.querySelectorAll('input:not([type="hidden"]):not([readonly])').forEach((input) => {
        input.addEventListener('change', this.onOptionChangeHandler.bind(this));
      });

      const inputText = this.querySelector('input[name="items[0][properties][_TEXT]"]');
      if (inputText) inputText.addEventListener('input', this.onTextChangeHandler.bind(this));

      const inputFont = this.querySelectorAll('input[name="items[0][properties][_FONT]"]');
      if (inputFont) inputFont.forEach((input) => {
        input.addEventListener('change', this.onFontChangeHandler.bind(this));
      });
    }

    connectedCallback() {
      this._syncOptions();
    }

    _syncOptions() {
      // When a real option is changed, we should update the sticky option
      this.options.forEach(option => {
        const realOption = document.querySelector(`[name="${option.dataset.target}"]`);
        if (realOption) {
          realOption.addEventListener('change', () => {
            option.selectedIndex = realOption.selectedIndex;
          });
        }
      });

      // When a sticky option is changed, we should update the real option
      this.options.forEach(option => {
        option.addEventListener('change', () => {
          const realOption = document.querySelector(`[name="${option.dataset.target}"]`);
          if (realOption) {
            realOption.selectedIndex = option.selectedIndex;
            realOption.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    onFontChangeHandler(evt) {
      console.log(evt.target);
      const checked = evt.target.checked;
      const inputText = this.querySelector('input[name="items[0][properties][_TEXT]"]');
      if (!inputText) return;

      if (checked) {
        inputText.style.fontFamily = evt.target.dataset.fontFamily;
        inputText.style.fontWeight = evt.target.dataset.fontWeight;
      }
    }

    onTextChangeHandler(evt) {
      this.log.innerHTML = '';
      if (evt.target.value === '' || this.form.dataset.disabled === 'true' || evt.target.checkValidity() === false) {
        this.submitButton.disabled = true;

        if (evt.target.validationMessage !== '') {
          this.log.appendChild(
            Object.assign(document.createElement('p'), {
              textContent: evt.target.validationMessage,
            })
          );
        }
        return;
      }

      this.submitButton.disabled = false;
    }

    onOptionChangeHandler(evt) {
      const inputTargetId = evt.target.dataset.target;
      if (!inputTargetId) return;

      const inputTarget = document.getElementById(inputTargetId);
      if (!inputTarget) return;

      inputTarget.value = evt.target.value;

      if (evt.target.dataset.maxLength) {
        this.inputText.setAttribute('maxlength', evt.target.dataset.maxLength);
        this.inputTextValue.setAttribute('maxlength', evt.target.dataset.maxLength);
        this.inputText.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    get form() {
      return this.querySelector('[id^="product-form-broderie-"]');
    }

    get options() {
      return this.querySelectorAll('[id^="Option-"]');
    }

    get submitButton() {
      return this.querySelector('button[type="submit"]');
    }
  });
}